<template>
  <a-modal
    title="统计终端用户近12月用水量"
    :visible="showTubeView"
    :width="1000"
    destroyOnClose
    @ok="closeTubeView"
    @cancel="closeTubeView"
  >
    <a-row :gutter="48">
      <a-col :md="24" :sm="24">
        <WaterLineChart :data="listData" />
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import moment from 'moment'
import { Transfer } from 'ant-design-vue'
import WaterLineChart from '@/components/Charts/waterLineChart'
export default {
  components: {
    WaterLineChart
  },
  data() {
    return {
      showTubeView: false,
      listData: {}
    }
  },

  computed: {
    rules() {
      return {}
    }
  },
  mounted() {},
  created() {},
  methods: {
    getList(appearanceNo) {
      this.$http
        .get('/pipe-network/yc_user_remote_water_meters/water/consumption', { params: { appearance_no: appearanceNo } })
        .then(res => {
          
          let list = res.data
          var xdata = []
          var sdata = []
          list.map(item => {
            item.meterNumber=parseFloat(item.meterNumber).toFixed(2)
            xdata.push(item.time)
            sdata.push(item.meterNumber)
          })
          this.listData = {
            xdata: xdata,
            sdata: sdata,
            color: [
              new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#18B0DD' }, //柱图渐变色
                { offset: 1, color: '#2A80E8' } //柱图渐变色
              ])
            ],
            grid: {
              x: '8%', //左侧与y轴的距离
              y:'20%', //top部与x轴的距离
              x2: '2%', //右侧与y轴的距离
              y2: '16%' //bottom部与x轴的距离
            },
            line:true
          }
        })
    },
    edit(appearanceNo) {
      console.log(appearanceNo)

      this.getList(appearanceNo)
      this.showTubeView = true
    },
    closeTubeView() {
      this.showTubeView = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
